module.exports = __webpack_public_path__ + "media/src/assets/images/amenities_blue/tea_set-86d2c49f050c323d748946371eb54f6a.svg";